import {Link} from "react-router-dom";
import React from "react";

export const PaymentSuccess = () => {
  return (
      <div className={"PaymentSuccess contentArea"}>
        <div className={"content"}>
          <p>Great, you're all setup with Swurf!</p>
          <Link className={"button"} to={"/"}>Return home</Link>
        </div>
      </div>
  )
}
